import gql from 'graphql-tag';

const GET_EVENT_GROUP_BY_WORKSPACE_ID = gql`
  query GetEventGroupsByWorkspaceId($workspaceId: ID!) {
    getEventGroupsByWorkspaceId(workspaceId: $workspaceId) {
      eventGroups {
        id
        deviceTypes
        name
        workspaceId
        isDefault
        custom {
          id
          deviceTypes
          name
        }
      }
    }
  }
`;

export default {
  GET_EVENT_GROUP_BY_WORKSPACE_ID,
};
